import { useMutation } from '@apollo/client';

import { useToast } from '../../toast/Toast.context';
import {
  CREATE_CARPOOL_TRIP,
  CreateCarpoolTripMutation,
  CreateCarpoolTripMutationVariables,
} from '../graphql/mutation/createCarpoolTripMutation.graphql';
import {
  CARPOOL_TRIPS,
  CarpoolTripsQueryVariables,
} from '../graphql/query/carpoolTripsQuery.graphql';

export const useCreateCarpoolTripMutation = () => {
  const { showToast } = useToast();
  const [mutate] = useMutation<
    CreateCarpoolTripMutation,
    CreateCarpoolTripMutationVariables
  >(CREATE_CARPOOL_TRIP);

  const createCarpoolTrip = async (
    variables: CreateCarpoolTripMutationVariables,
  ) => {
    await mutate({
      variables,
      refetchQueries: [
        {
          query: CARPOOL_TRIPS,
          variables: {
            eventId: variables.createCarpoolTripInput.eventId,
          } satisfies CarpoolTripsQueryVariables,
        },
      ],
    });

    showToast({
      type: 'success',
      message: 'Trajet proposé.',
    });
  };

  return { createCarpoolTrip };
};
